import { createRef } from 'react';

import { HilmaSocket } from '../types';

const createSocketRef = () => createRef<HilmaSocket>();

export default createSocketRef;